import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'app-oview',
	templateUrl: './oview.component.html',
	styleUrls: ['./oview.component.css']
})
export class OviewComponent implements OnInit {

	logi_user:any;
	idx:any;
	orData:any = [];

	constructor(
		private http: HttpClient,
		private router: Router,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) { }

	ngOnInit() {

		if( this.getData['idx'] == null || this.getData['idx'] == "undefined" ){ this.idx = ""; }
		else{ this.idx = this.getData['idx']; }

		if( this.getData['idx'] )
		{
			this.getOrderData(this.getData['idx']);
		}
	}

	async getOrderData(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/order.data.php', formData).subscribe((response) => {
			if( response['data'] )
			{
				this.orData = response['data'];
			}
		});
	}

	async orderCopy(idx) {
	}

	async orderCancel(idx) {
	}

	async closeModal() {
		this.dialogRef.close();
	}
}
